module.exports = __webpack_public_path__ + "img/user10.1ae37da9.jpg";